import { FC, useContext } from 'react';

import useTimeZone from 'hooks/use-timezone';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryExpirationDate: FC<{ className?: string }> = ({ className = '' }) => {
  const { dateInputToUtc, utcToZonedDate } = useTimeZone();
  const { expirationDate, setExpirationDate, startDate } = useContext(RedeliveryContext);

  return (
    <div className={`text-field ${className}`}>
      <input
        className="h-100 w-100"
        data-cy="redelivery-expiration-date-input"
        min={utcToZonedDate(startDate)}
        onChange={e => setExpirationDate(dateInputToUtc(e.target.value))}
        required
        ref={node => node?.classList.toggle('blank', !expirationDate)}
        type="date"
        value={utcToZonedDate(expirationDate)}
      />
      <label>EXPIRATION DATE</label>
    </div>
  );
};

export default RedeliveryExpirationDate;
